import { FC, useState } from 'react';

import AccountTypeRadioOption from './AccountTypeRadioOption';
import CapabilityList from './CapabilityList';
import { RadioGroupOption } from './acl-types';
import { getRoleRadioGroupOptions } from './acl-util';

// generated
import { AclWorkspaceServiceRelationship, Option, Permission } from '../../../api/gql/graphql';

// @tecton
import { ComboBox, FlexGroupWrapper, FlexItem } from '@tecton/ComponentRedesign';
import { ACLModalFormWrapper } from './StyledComponents';

interface AddWorkspaceAccessProps {
  roles: RadioGroupOption[];
  assignableWorkspaces: Option[];
  workspaceRole?: AclWorkspaceServiceRelationship;
  roleDescriptionMap?: Record<string, Permission[]>;
  onRoleChange: (roleName: string /** undefined means the selection didn't change */) => void;
  onWorkspaceSelected: (workspace: string) => void;
}

const AddWorkspaceAccess: FC<AddWorkspaceAccessProps> = ({
  roles,
  assignableWorkspaces,
  workspaceRole,
  roleDescriptionMap,
  onRoleChange,
  onWorkspaceSelected,
}) => {
  const permissions = roleDescriptionMap ? roleDescriptionMap[`${workspaceRole?.role?.effectiveWorkspaceRole}`] : [];

  // general state
  const [roleDescription, setRoleDescription] = useState<Permission[]>(permissions);
  const [selectedOptions, setSelected] = useState<Option[]>([]);

  const [options, setOptions] = useState<RadioGroupOption[]>(
    getRoleRadioGroupOptions(roles, workspaceRole?.role?.effectiveWorkspaceRole)
  );

  return (
    <>
      <FlexGroupWrapper gap="l" direction="column">
        <FlexItem grow={true}>
          <ComboBox
            placeholder="Select a Workspace"
            singleSelection={{ asPlainText: true }}
            options={assignableWorkspaces}
            fullWidth={true}
            selectedOptions={selectedOptions}
            onChange={(selectedOptions) => {
              const selected = selectedOptions[0]?.label;
              onWorkspaceSelected(selected);
              setSelected(selectedOptions);
            }}
          />
        </FlexItem>
        <FlexItem>
          <ACLModalFormWrapper>
            <FlexGroupWrapper gap="xl" direction="row">
              <FlexItem grow={8}>
                <AccountTypeRadioOption
                  options={options ?? []}
                  onSelection={(selectedOption) => {
                    const permissions = roleDescriptionMap ? roleDescriptionMap[`${selectedOption?.label}`] : [];
                    setOptions(getRoleRadioGroupOptions(roles, selectedOption?.label ?? ''));
                    setRoleDescription(permissions);
                    onRoleChange(selectedOption?.label ?? '');
                  }}
                />
              </FlexItem>
              <FlexItem grow={6}>
                <CapabilityList roleDescriptions={roleDescription ?? []} maxHeight={600} />
              </FlexItem>
            </FlexGroupWrapper>
          </ACLModalFormWrapper>
        </FlexItem>
      </FlexGroupWrapper>
    </>
  );
};

export default AddWorkspaceAccess;
